import * as React from "react"

const SvgComponent = (props) => (
  <svg
    width={15}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.69.87c5.805 0 8.997 6.626 5.628 11.17-2.556 3.445-7.64 3.788-10.632.73C-1.591 8.4 1.443.87 7.69.87ZM6.339 7.084 5.08 12.388l3.964-3.742 1.258-5.304L6.34 7.084Zm1.669.233c.48.278.387 1.001-.134 1.155a.644.644 0 0 1-.79-.42c-.168-.536.425-1.023.924-.735ZM7.69 2.15c4.742 0 7.35 5.413 4.598 9.124-2.088 2.815-6.242 3.096-8.687.597C.108 8.301 2.587 2.15 7.691 2.15Z"
      fill="#636F7C"
    />
  </svg>
)

export default SvgComponent